import * as React from 'react';
import {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import ShareIcon from '@mui/icons-material/Share';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {Select} from '@mui/material';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';


const SHARE_AS_OPTIONS = {
  Link: 'Link',
  Image: 'Image',
  Text: 'Text'
}

const SHARE_AS_IMAGE_OPTIONS = {
  QUESTION: 'QUESTION',
  QUESTION_WITH_OPTIONS: 'QUESTION_WITH_OPTIONS',
  QUESTION_AND_RESULTS: 'QUESTION_AND_RESULTS'
}

function SimpleDialog(props) {
  const {onClose, open, resultImage, screenshotRef} = props;
  const {Image, Link, Text} = SHARE_AS_OPTIONS
  const {QUESTION, QUESTION_AND_RESULTS, QUESTION_WITH_OPTIONS} = SHARE_AS_IMAGE_OPTIONS
  const [shareAsOption, setShareAsOption] = useState(Image)
  const [shareAsMoreOption, setShareAsMoreOption] = useState(QUESTION_WITH_OPTIONS)
  const [showAlert, setShowAlert] = useState(false)

  const handleShareAsOptionChange = (event) => {
    setShareAsOption(event.target.value)
  }

  const handleDropDownChange = (eventDD) => {
    setShareAsMoreOption(eventDD.target.value)
  }

  const onClickShare = () => {
    setShowAlert(true)
  }

  const renderShareAsMoreOptions = () => {
    return <FormControl sx={{ml: 0, mt: 1, mb: 2}} fullWidth>
      <FormLabel id="demo-radio-buttons-group-label">Type </FormLabel>
      {shareAsOption !== Link ? <>
          <Select value={shareAsMoreOption} id="unnamed-select" onChange={handleDropDownChange}>
            {Object.entries(SHARE_AS_IMAGE_OPTIONS).map(([key, value]) => {
              return <MenuItem value={value}>{value}</MenuItem>
            })
            }
          </Select>
        </>
        : <Button variant="text">Click here to copy link</Button>}
    </FormControl>
  }

  useEffect(() => {

  })

  return (
    <Dialog onClose={onClose} open={open}>
      <Box sx={{ml: 1, mt: 1}}>
        {/*<DialogTitle>Share</DialogTitle>*/}
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">Share as </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={shareAsOption}
            name="radio-buttons-group"
            onChange={handleShareAsOptionChange}
          >
            {Object.entries(SHARE_AS_OPTIONS).map(([key, value]) => {
              return <FormControlLabel key={key} value={key} control={<Radio/>} label={value}/>
            })}
          </RadioGroup>
        </FormControl>
        {renderShareAsMoreOptions()}

        <img width={200} height={200} border={'1px solid blue'} src={resultImage} alt={'ScreenShot'}/>


        <Stack direction="row" spacing={2} sx={{mb: 2}}>
          <Button variant="contained" onClick={onClickShare}>Share</Button>
          <Button variant="outlined" onClick={onClose}>Close</Button>
        </Stack>


        {showAlert && <Alert severity="success" color="success">
          Shared successfully
        </Alert>}

      </Box>
    </Dialog>
  );
}

export default function ShareDialog({resultImage, screenshotRef}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton aria-label="share" onClick={handleClickOpen}>
        <ShareIcon/>
        <Typography variant="body2">
          Share
        </Typography>
      </IconButton>

      <SimpleDialog
        open={open}
        onClose={handleClose}
        resultImage={resultImage}
        screenshotRef={screenshotRef}
      />
    </div>
  );
}
